export default __webpack_public_path__ + "images/gw-header-image-100.png?5fef314ebc53dc1f3bdf0be8214d7a7d";